<template>
  <div>
    <header class="main-header position-relative w-100 py-12 px-16 d-flex align-items-center bg-dark-gray">
      <div class="d-flex justify-self-start left-nav-content align-items-center pe-20">
        <a
          class="return-btn align-items-center d-flex text-decoration-none"
        >
          <span class="custom-icon">
            <icon name="backicon"/>
          </span>
          <span
            type="button"
            class="return-text"
            @click="onReturnBack">Return to classic editor</span>
        </a>
      </div>
      <div class=" breadcrumb-wrapper d-flex justify-content-lg-center">
        <ul
          v-if="0"
          class="breadcrumb bg-transparent mb-0 pb-0">
          <li class="breadcrumb-item ext-decoration-none text-gray-50">{{ getProductTitle }}</li>
        </ul>

      </div>
      <div class="avatar-section d-flex justify-content-end right-nav-content">
        <ul class="buttons-group-wrapper list-unstyled d-flex mb-0 align-items-center">
          <li
            v-if="isDownloadVideoInprogress"
            class="me-15">
            <span
              class="text-light"
            >Download Progress 50%</span>
          </li>
          <li
            v-if="0"
            class="me-15"><select
              v-model="selectedProduct"
              class="custom-select rounded rounded-4"
              @change="updateSelectedProduct">
              <option
                v-for="(item,index) in productsData"
                :key="index"
                :value="item">{{ "Product "+ (index+1) }}</option>
          </select></li>
          <li v-if="!isDownloadVideoInprogress">
            <button
              :disabled="isPDFProcessing"
              class="btn-primary bm-primary-btn me-15 position-relative"
              @click.self="handlePreviewClick">
              <span
                v-if="isPDFProcessing"
                class="d-inline-block"> <i class="fa  fa-refresh fa-spin me-4"/></span>
              Preview
              <div
                v-if="showPreviewDD"
                class="closer"
                @click.self="showPreviewDD = false"/>
              <ul
                :class="{'d-block':showPreviewDD}"
                class=" drop-down-list list-unstyled position-absolute save-menu "
                style="z-index: 99999;"
              >
                <li>
                  <div
                    :disabled="isPDFProcessing"
                    :class="isPDFProcessing ? 'disable-button':''"
                    type="button"
                    @click="generatePDF"
                  >
                    <span v-if="!isPDFProcessing">Preview Image</span>
                    <span
                      v-if="isPDFProcessing"
                      class="d-inline-block"> <i class="fa  fa-refresh fa-spin "/>  <span style="padding:0 5px">{{ " Preparing..." }}</span></span>
                  </div>
                </li>
                <li v-if="isVideoMoodOn">
                  <div @click.stop="previewVideo">
                    Preview Video
                  </div>
                </li>
              </ul>
            </button>
          </li>
          <li
            v-show="false"
            class="me-15">
            <button
              class="btn-primary bm-primary-btn"
              @click.stop="previewProduct">Preview</button>
          </li>
          <li class="me-15">
            <button
              :class="[isDropdownOpen ? 'show-dropdown':'hide-dropdown']"
              class="bm-secondary-btn position-relative"
            ><span @click.stop="onSaveProduct">Save</span>
              <span
                class="right-icon ms-14"
                @click="openDropDown"
              >
                <icon
                  name="chevrondown"
                  class="custom-icon"/>
              </span>
              <div
                v-if="isDropdownOpen"
                class="closer"
                @click.self="isDropdownOpen = false"/>
              <ul
                class=" drop-down-list list-unstyled position-absolute save-menu save-dd"
                style="z-index:99999;">
                <li @click.stop="createNewOrder">Save</li>
                <li @click.stop="saveAsOrder">Save as..</li>
                <li @click.stop="updateOrder">Save and close</li>
                <li @click.stop="saveAsTemplate">Save as template</li>
              </ul>

            </button>
          </li>

          <li>
            <button
              class="bm-secondary-btn "
              @click.self.stop="handleSubmitClick"
            >Submit
              <div
                v-if="showSubmitDD"
                class="closer"
                @click.self="showSubmitDD = false"/>
              <ul
                v-if="showSubmitDD"
                class="drop-down-list list-unstyled position-absolute save-menu d-block"
                style="margin-top:24px; right:2px; z-index:99999;">
                <li @click.stop="onSubmitProduct">Submit Image</li>
                <li
                  v-if="isVideoMoodOn"
                  @click.stop="onSubmitProductWithVideo">Submit Video</li>
              </ul>
            </button>
          </li>
        </ul>
        <div
          v-if="0"
          class="avatar-image-wrapper ms-28 border border-white border-1">
          <img src="../../assets/images/avatar.png">
        </div>
      </div>
    </header>
    <div
      id="main_html_hide_div"
      class="d-none">
      <canvas-section
        v-for="(productPage , index) in getProductPages"
        v-if="isPDFProcessing || isGeneratePDFWithOutProof"
        :height="productCrop.AllowCropping? productPage.height - productCrop.YCrop: productPage.height"
        :width="productCrop.AllowCropping? productPage.width - productCrop.XCrop: productPage.width"
        :scale="100"
        :base-image="productPage.baseImage"
        :content-list="productPage.objectList"
        :active-page="productActivePage"
        :product-crop="productCrop"
        :key="productPage.baseImage"
        :is-fake-rendering="true"
        :rendering-order="index"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import mime from 'mime';
import EventBus from '@/EventBus';
import Canvas from '@/components/Canvas/Canvas.vue';
import _ from 'lodash';
import productData from '../../config/productData.json';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';

export default {
  name:       'Header',
  components: { 'canvas-section': Canvas },
  props:      {},
  data() {
    return {
      productsData:              [],
      contentList:               [],
      selectedPageWidth:         0,
      selectedPageHeight:        0,
      selectedProduct:           productData.products[0],
      selectedProductId:         productData.products[0].productId,
      selectedBankId:            'fde5ed9d-816f-43fd-89f3-97a542947193',
      orderItemId:               '',
      isPDFProcessing:           false,
      isTempPdfFunctionCalled:   false,
      isPDFProcessingTest:       false,
      productCrop:               null,
      loadedProduct:             null,
      productActivePageIndex:    0,
      productActivePage:         0,
      isDropdownOpen:            false,
      undoRedoArrayLength:       -1,
      isPreviewPdf:              false,
      isGeneratePDFWithOutProof: false,
      showPreviewDD:             false,
      showSubmitDD:              false,
      isPreviewVideo:            false,
    };
  },
  computed: {
    isVideoMoodOn() {
      return this.$store.getters['activeProduct/getIsVideoMoodOn'];
    },
    getProductPages() {
      if (!this.loadedProduct) { return []; }
      return this.loadedProduct.pages;
    },
    getProductTitle() {
      if (!this.loadedProduct || !this.loadedProduct.Name) { return ''; }
      return this.loadedProduct.Name;
    },
    isDownloadVideoInprogress() {
      return this.$store.getters['activeProduct/getIsDownloadInprogress'];
    },
  },
  mounted() {
    this.productsData = productData.products;
    this.loadProductFromUrlUsingAPI();
    EventBus.$on('updateProductInHeader', this.onUpdateProductInHeader);
    EventBus.$on('updateSelectedPageHeightInHeader', this.onUpdateSelectedPageHeightInHeader);
    EventBus.$on('updateSelectedPageWidthInHeader', this.onUpdateSelectedPageWidthInHeader);
    EventBus.$on('updateProductCropMark', this.onUpdateProductCropMark);
    EventBus.$on('onUpdateProduct', this.onUpdateProduct);
    EventBus.$on('updateProductActivePageIndex', this.onUpdateProductActivePageIndex);
  },
  beforeDestroy() {
    EventBus.$off('updateProductCropMark');
    EventBus.$off('updateProductInHeader');
    EventBus.$off('updateSelectedPageHeightInHeader');
    EventBus.$off('updateSelectedPageWidthInHeader');
    EventBus.$off('onUpdateProduct', this.onUpdateProduct);
    EventBus.$off('updateProductActivePageIndex', this.onUpdateProductActivePageIndex);
  },
  methods: {
    previewVideo() {
      EventBus.$emit('showHideLoader', true);
      this.$store.commit('setPreviewClicked', 'video');
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
      EventBus.$emit('unSelectAudioLayer');
      this.isPreviewVideo      = true;
      this.undoRedoArrayLength = this.$store.getters.getUndoRedoArrayListLength;
      this.$store.commit('setDisplayPreviewModal', true);
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
    },
    async renderAllPage(tempDiv) {
      const multiPages = [];
      // tempDiv = document.getElementById('main_html_hide_div').cloneNode(true);

      // const tempClonedHtmlElement = document.getElementById('main_html').cloneNode(true);
      /*
        did this to remove references clone was not working for img tags
        we have to remove references bcs we will replace resources only for PDF not for Editor
        */
      for (let pageIndex = 0; pageIndex < tempDiv.children.length; pageIndex += 1) {
        const clonedHtmlElement = tempDiv.children[pageIndex];
        // make scale 1 for pdf
        const {
          AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
        } = this.productCrop;
        // ${AllowCropping ? `translate(-${XCrop}px, -${YCrop}px)` : ''}
        const transform                   = 'scale(1) ';
        clonedHtmlElement.style.transform = 'scale(1) ';
        clonedHtmlElement.style.position  = 'absolute';
        clonedHtmlElement.style.left      = AllowCropping ? `-${XCrop}px` : '0';
        clonedHtmlElement.style.top       = AllowCropping ? `-${YCrop}px` : '0';
        clonedHtmlElement.style.marginLeft && (clonedHtmlElement.style.marginLeft = '');
        clonedHtmlElement.style.marginTop && (clonedHtmlElement.style.marginTop = '');
        clonedHtmlElement.style.removeProperty('filter');
        // remove tinymce classes if editor enable
        const element = clonedHtmlElement.querySelectorAll('.focus-text-editor ', '.fmce-edit-focus')[0];
        if (element) {
          element.classList.remove('focus-text-editor');
          element.classList.remove('fmce-edit-focus');
        }
        const activeElement = document.getElementById(clonedHtmlElement.Id);
        activeElement && (activeElement.style.overflowY = 'initial');
        let pageWidth  = parseInt(clonedHtmlElement.style.width, 10);
        let pageHeight = parseInt(clonedHtmlElement.style.height, 10);

        if (AllowCropping) {
          pageHeight = HeightCrop;
          pageWidth  = WidthCrop;
        }

        if (!this.isGeneratePDFWithOutProof) {
          const waterMark = document.createElement('div');
          waterMark.classList.add('water-mark-div');
          waterMark.innerHTML = '<div class="water-mark-child">PROOF</div>';
          clonedHtmlElement.insertBefore(waterMark, clonedHtmlElement.firstChild);
        }
        const canvasWrapper = document.createElement('div');
        canvasWrapper.appendChild(clonedHtmlElement.cloneNode(true));
        canvasWrapper.style.width    = `${pageWidth}px`;
        canvasWrapper.style.height   = `${pageHeight}px`;
        canvasWrapper.style.position = 'relative';
        canvasWrapper.style.overflow = 'hidden';

        this.makeHtmlPage(canvasWrapper).then((htmlString) => {
          const pdfPage = {
            htmlString, 'viewport-width':  parseInt(pageWidth, 10), 'viewport-height': parseInt(pageHeight, 10), 'paper-height':    pageHeight * 0.013888888888888888, 'paper-width':     pageWidth * 0.013888888888888888,
          };
          multiPages.push(pdfPage);
        });
      }

      return multiPages;
    },
    getValueInches(px) {
      const inchesVal = 0.013888888888888888;
      return parseFloat((px * inchesVal).toFixed(1));
    },
    onUpdateProductInHeader(product) {
      this.contentList = product;
    },
    onUpdateProduct(product) {
      this.loadedProduct = product;
    },
    onUpdateProductActivePageIndex(index) {
      this.productActivePageIndex = index;
    },
    onUpdateSelectedPageHeightInHeader(height) {
      this.selectedPageHeight = height;
    },
    onUpdateSelectedPageWidthInHeader(width) {
      this.selectedPageWidth = width;
    },
    onUpdateProductCropMark(productCrop) {
      this.productCrop = productCrop;
    },
    makeLoaderVisible() {
      EventBus.$emit('showHideLoader', true);
    },
    makeLoaderInVisible() {
      EventBus.$emit('showHideLoader', false);
    },
    updateSelectedProduct() {
      EventBus.$emit('onDeselectObject');
      this.selectedProductId = this.selectedProduct.productId;

      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      if (newUrlSearchParams.has('orderitemId')) {
        const parser               = new DOMParser();
        const xmlParsed            = parser.parseFromString(this.selectedProduct.xml, 'text/xml');
        const newEditorGetResponse = xmlParsed.getElementsByTagName('NewEditorGetResult');
        EventBus.$emit('loadProductFromJson', { orderJson: newEditorGetResponse[0] ? newEditorGetResponse[0].innerHTML : '', orderName: '' });
      } else { EventBus.$emit('selectedProductOption', this.selectedProduct.xml); }
      this.resetInchesDropDownToPixelsOnProductChange();
      this.resetPanelsInLeftSection();
      this.$store.commit('updateZoomLevel', 0);
    },
    async loadProductFromUrlUsingAPI() {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const isTemplate         = newUrlSearchParams.has('isTemplate') ? newUrlSearchParams.get('isTemplate') : false;
      newUrlSearchParams.has('redirectUrl') && (this.$store.commit('setRedirectUrl', newUrlSearchParams.get('redirectUrl')));
      let bankId       = 'fde5ed9d-816f-43fd-89f3-97a542947193';
      let method       = 'GetProductInfo';
      this.orderItemId = newUrlSearchParams.has('orderitem_id') ? 'orderitem_id' : 'orderitem_Id';
      const temVar     = newUrlSearchParams.has(this.orderItemId) ? this.orderItemId : 'productId'; // 'orderitem_id'
      if (!newUrlSearchParams.has(temVar) || !newUrlSearchParams.has('userId')) {
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'LoadingProductErrorMessage', message: `Please make sure ${temVar} and userId is passed` });
        return;
      }
      newUrlSearchParams.has('productId') && (this.selectedProductId = newUrlSearchParams.get('productId'));
      newUrlSearchParams.has('bankId') && (bankId = newUrlSearchParams.get('bankId'));

      if (newUrlSearchParams.has(this.orderItemId)) {
        method                 = 'GetProductInfoForOrder';
        this.selectedProductId =  newUrlSearchParams.get(this.orderItemId);
        this.$store.commit('updateOrderItemId', this.selectedProductId);
      } else {
        this.$store.commit('updateOrderItemId', '');
      }

      if (bankId) {
        this.$store.commit('updateBankId', bankId);
        this.selectedBankId = bankId;
      }
      if (userId) {
        this.$store.commit('updateUserId', userId);
      }
      this.makeLoaderVisible();

      EventBus.$emit('onDeselectObject');

      let orderItemRes = '';

      method === 'GetProductInfoForOrder' && (orderItemRes = await this.getNewProductByOrder(this.selectedProductId));

      console.log('NewOrderJsonResponse', orderItemRes);

      if (orderItemRes) {
        EventBus.$emit('loadProductFromJson', orderItemRes);
        return;
      }

      let templateResponse = '';
      if (isTemplate === 'true' || isTemplate === true) {
        method           = 'GetProductInfoNewEditor';
        templateResponse = await this.getTemplateProduct(this.selectedProductId, bankId, userId);
        EventBus.$emit('loadProductFromJson', templateResponse);
      }

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=${method}&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&productId=${this.selectedProductId}`;


      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.loadColorAndProduct);
      oReq.addEventListener('error', (e) => {
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },

    async getTemplateProduct(productId, bankId, userId) {
      const bmcInstance = this.$store.getters.getBMCInstance;
      const domainUrl   = bmcInstance === 'marketingcenter.source4' ? bmcInstance : `www.${bmcInstance}`;
      const baseUrl     = this.$store.getters.getBaseUrl;
      const url         = `${baseUrl}/web_service.aspx?method=GetProductInfoNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&productId=${productId}`;

      try {
        const res                  = await axios.get(url);
        const parser               = new DOMParser();
        const xmlParsed            = parser.parseFromString(res.data, 'text/xml');
        const newEditorGetResponse = xmlParsed.getElementsByTagName('GetProductInfoNewEditorResult')[0];

        if (!newEditorGetResponse) {
          return '';
        }

        const newEditorGetResponseText = newEditorGetResponse.innerHTML;
        const newEditorGetResponseJSON = JSON.parse(newEditorGetResponseText);
        console.log('newEditorGetResponse', newEditorGetResponseJSON);

        return { orderJson: newEditorGetResponseText, orderName: newEditorGetResponseJSON.Name };
      } catch (error) {
        console.error('Error fetching template product:', error);
        return '';
      }
    },


    updateSelectedProductFromAPI() {
      this.makeLoaderVisible();
      EventBus.$emit('onDeselectObject');
      this.selectedProductId   = this.selectedProduct.productId;
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;
      // const userId = '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      const bankId    = 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetProductInfo&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&productId=${this.selectedProductId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.loadColorAndProduct);
      oReq.addEventListener('error', (e) => {
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadColorAndProduct(data) {
      // const url = new URL('https://dev2.wysiwyg.bankmarketingcenter.com/newBMC/web_service.aspx?');
      // url.searchParams.set('method', 'GetPmsColorNewInfo');
      // url.searchParams.set('domainURL', 'https://www.bankmarketingcenter.com/');
      // url.searchParams.set('bankId', this.selectedBankId);
      // url.searchParams.set('productId', this.selectedProductId);
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetPmsColorNewInfo&domainURL=https://${domainUrl}.com/&bankId=${this.selectedBankId}&productId=${this.selectedProductId}`;


      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (colorResponse) => {
        this.colorCMYK = colorResponse.target.response;

        EventBus.$emit('selectedProductOption', data.target.response);


        this.resetInchesDropDownToPixelsOnProductChange();
        this.resetPanelsInLeftSection();
        this.makeLoaderInVisible();
      });
      oReq.addEventListener('error', (e) => {
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    generatePDF(forTemplate = false) {
      // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      !this.isGeneratePDFWithOutProof && (this.isPDFProcessing = true);
      this.$store.commit('setPreviewClicked', 'image');
      // generate html page for pdf
      this.checkCanvasSectionRender().then((pagesDiv) => {
        this.renderAllPage(pagesDiv).then((multiPages) => {
          this.saveHTMLForPDF(multiPages, forTemplate);
        }).catch((error) => {
          this.isGeneratePDFWithOutProof && (EventBus.$emit('showHideLoader', false));
          this.isPDFProcessing           = false;
          this.isGeneratePDFWithOutProof = false;
        });
      });
    },
    async checkCanvasSectionRender() {
      let canvasSection = null;
      while (canvasSection == null) {
        const canvasDiv = document.getElementById('main_html_hide_div').cloneNode(true);
        canvasSection   = (canvasDiv && canvasDiv.children && canvasDiv.children.length === this.loadedProduct.pages.length && this.checkCanvasPagesRender(canvasDiv.children, this.loadedProduct.pages)) ? canvasDiv : null;
        await new Promise(r => setTimeout(r, 500));
      }
      return canvasSection;
    },
    checkCanvasPagesRender(pagesDiv, productPages) {
      for (let pageIndex = 0; pageIndex < productPages.length; pageIndex++) {
        if (productPages[pageIndex].objectList.length > 0 && productPages[pageIndex].objectList.length != pagesDiv[pageIndex].children.length) {
          return false;
        }
      }
      return true;
    },
    async makeHtmlPage(htmlElement) {
      const html = this.convertImageTagToObject(htmlElement);

      return html;
    },
    saveHTMLForPDF(multiPages, forTemplate = false) {
      // as discus preview 0 for saving pdf to azure storage
      axios.post('https://pdf-processing.bankmarketingcenter.com/node/multipage4', {
        thumbnail: true, pdfHTML:   multiPages, preview:   this.isGeneratePDFWithOutProof ? 0 : 1, grayscale: this.loadedProduct.IsGrayscale,
      })
        .then((response) => {
          if (this.isGeneratePDFWithOutProof) {
            this.isGeneratePDFWithOutProof = false;
            if (forTemplate) {
              EventBus.$emit(ApplicationEventTypes.ProductSave.SAVE_PRODUCT_AS_TEMPLATE, response.data.pdf);
            } else {
              EventBus.$emit('saveProduct', response.data.pdf);
            }
          } else {
            window.open(response.data.pdf);
            this.isPDFProcessing     = false;
            this.isPreviewPdf        = true;
            this.undoRedoArrayLength = this.$store.getters.getUndoRedoArrayListLength;
          }

          // now page is saved we call PDF function
          // this.makePdfForHtmlPage(data);
        })
        .catch((error) => {
          console.error(error);
          this.isGeneratePDFWithOutProof && (EventBus.$emit('showHideLoader', false));
          this.isPDFProcessing           = false;
          this.isGeneratePDFWithOutProof = false;
          this.isPreviewPdf              = false;
        });
    },
    convertSvgToBase64(productHtml) {
      const svgElements = productHtml.querySelectorAll('svg');
      for (let i = 0; i < svgElements.length; i++) {
        // Create your own image
        const img = document.createElement('img');
        // Serialize the svg to string
        const svgString = new XMLSerializer().serializeToString(svgElements[i]);
        // Remove any characters outside the Latin1 range
        const decoded = unescape(encodeURIComponent(svgString));
        // Now we can use btoa to convert the svg to base64
        const base64    = btoa(decoded);
        const imgSource = `data:image/svg+xml;base64,${base64}`;
        img.setAttribute('src', imgSource);
        svgElements[i].parentNode.appendChild(img);
        svgElements[i].remove();
      }
      return this.convertImageTagToObject(productHtml);
    },
    convertImageTagToObject(productHtml) {
      // let selectedObject=null
      const imageElements = productHtml.querySelectorAll('img');
      for (let i = 0; i < imageElements.length; i++) {
        let src =  imageElements[i].getAttribute('src');

        if (imageElements[i].getAttribute('data-highImage') && imageElements[i].getAttribute('data-highImage') !== 'undefined' && !imageElements[i].getAttribute('data-highImage').toLowerCase().endsWith('.pdf')) {
          src = imageElements[i].getAttribute('data-highImage');
        }

        if (src.lastIndexOf('.') < src.lastIndexOf('#')) { src = src.slice(0, src.lastIndexOf('#')); }
        src = src.trim();

        if (src.endsWith('.pdf')) {
          const url = new URL(src);
          src       = url.pathname;
        }

        let mimeType = mime.getType(src.replace(/(\r\n|\n|\r)/gm, ''));
        mimeType     = src.startsWith('data:image/svg+xml;base64') ? mime.getType('123.svg') : mimeType;

        const newObj = document.createElement('object');
        newObj.setAttribute('data', src);
        newObj.setAttribute('type', mimeType);
        newObj.setAttribute('width', parseInt(imageElements[i].parentElement.style.width, 10));
        newObj.setAttribute('height', parseInt(imageElements[i].parentElement.style.height, 10));
        newObj.setAttribute('style', '');
        if (mimeType === 'image/svg+xml') {
          const parentDiv              = imageElements[i].parentElement;
          const scaleX                 = parentDiv.getAttribute('data-scalex') ? parseFloat(parentDiv.getAttribute('data-scalex')) : 1;
          const scaleY                 = parentDiv.getAttribute('data-scaley') ? parseFloat(parentDiv.getAttribute('data-scaley')) : 1;
          const degree                 = parentDiv.getAttribute('data-rotate') ? parseFloat(parentDiv.getAttribute('data-rotate')) : 1;
          newObj.style.transform       = `scale(${scaleX},${scaleY}) rotate(0deg)`;
          newObj.style.transformOrigin = 'left top';
          newObj.style.position        = 'inherit';
          parentDiv.style.transform    = `rotate(${degree}deg)`;
          newObj.setAttribute('width', imageElements[i].parentElement.style.width);
          newObj.setAttribute('height', imageElements[i].parentElement.style.height);
          const width            = parseFloat(imageElements[i].parentElement.style.width) * scaleX;
          const height           = parseFloat(imageElements[i].parentElement.style.height) * scaleY;
          parentDiv.style.width  = `${width}px`;
          parentDiv.style.height = `${height}px`;
          parentDiv.classList && (parentDiv.classList.remove('d-flex'));
        } else {
          newObj.style.transform = imageElements[i].style.transform;
        }

        imageElements[i].parentElement.insertBefore(newObj, imageElements[i].parentElement.firstChild);
        imageElements[i].remove();
      }
      /**
       *
       * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
       * replacing top left with translate for SVG shapes
       */
      const shapeElements = productHtml.querySelectorAll('[data-type="shape"]');
      shapeElements.forEach((item) => {
        const { top, left }  = item.style;
        item.style.transform = `translate(${left}, ${top}) ${item.style.transform}`;
        item.style.top       = '';
        item.style.left      = '';
      });

      return productHtml.outerHTML;
    },
    replaceResourcesForPdf(htmlElement) {
      // getting all image elements to replace
      const allImageElements = htmlElement.querySelectorAll('[data-type= "image"]');
      if (allImageElements) {
        let imageObject = null;
        let index       = 0;
        let newSrc      = null;
        let fileType;
        for (let i = 0; i < allImageElements.length; i++) {
          index       = allImageElements[i].dataset.elementindex;
          imageObject = this.contentList[index];
          // this is hard coded logic function for product 11 only
          imageObject = this.hardCodedLogicForDemoProduct(imageObject);
          // now we have added all high resolution resources so we call replace them now
          if (imageObject && imageObject.srcForPdf) {
            newSrc = imageObject.srcForPdf;
            // we are getting file type to embed pdf
            fileType = newSrc.substring(newSrc.lastIndexOf('.') + 1, newSrc.length) || null;
            if (fileType) {
              // type PFD only for experiment for the time being we are using SVGs to replace resources
              if (fileType === 'pdf') {
                const newTag = document.createElement('iframe');
                newTag.setAttribute('src', newSrc);
                newTag.style.width  = `${imageObject.width}px`;
                newTag.style.height = `${imageObject.height}px`;
                allImageElements[i].removeChild(allImageElements[i].childNodes[0]);
                allImageElements[i].appendChild(newTag);
              } else {
                // here we actually replace resources for the PDF
                allImageElements[i].firstElementChild.src = imageObject.srcForPdf;
              }
            }
          }
        }
      }
      return htmlElement.outerHTML;
    },
    hardCodedLogicForDemoProduct(imageObject) {
      const objectIdVsPdfSrc = {
        'b5222806-aaa0-4082-a56a-909af321f093': '//173.230.137.214/htmlengine/img/fiblogo.svg',
        'e62076cf-7f94-4093-acea-1698fc116bb0': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdiclogo.svg',
        'b994abba-961f-4045-ab64-b0c3e65e0116': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/fdictext.svg',
        'd7d987a3-c0dd-4de8-8263-aaa8f1cfd9e9': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/ThinkstockPhotos-125917776019.jpg',
        '3ff179d8-37cc-496d-b247-082d346b181a': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder01.svg',
        '5557305c-5b0e-4a71-8ee5-e0d4a0aa7ac1': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder2044.svg',
        'e9ca3fc1-66e3-46b7-91bf-f2f8c4b96674': 'http://dev2.wysiwyg.bankmarketingcenter.com/BMCv2/img/zborder104.svg',
      };
      objectIdVsPdfSrc[imageObject.Id] && (imageObject.srcForPdf = objectIdVsPdfSrc[imageObject.Id]);
      return imageObject;
    },
    makePdfForHtmlPage(data) {
      // const url = '//173.230.137.214/pdfengine/createPDF.php';
      const url = 'https://pdf-processing.bankmarketingcenter.com/node/';
      axios.get(url, {
        params: {
          preview:           true,
          isGrayScale:       this.loadedProduct.IsGrayScale,
          'viewport-width':  parseInt(data.width),
          'viewport-height': parseInt(data.height),
          'paper-height':    (data.height / 72),
          'paper-width':     (data.width / 72),
          'page-url':        data.url,
        },
      })
        .then((response) => {
          window.open(`http://173.255.211.8:7000${response.data}`);
          this.isPDFProcessing = false;
        })
        .catch((error) => {
          console.error(error);
          this.isPDFProcessing = false;
        });
    },

    previewProduct() {
      EventBus.$emit('triggerUpdatePageContent');
      setTimeout(() => {
        EventBus.$emit('generateXML');
      }, 0);
      // Loader Active
      EventBus.$emit('showHideLoader', true);
    },
    resetInchesDropDownToPixelsOnProductChange() {
      EventBus.$emit('resetToPixels', this.resetInchesToPixels);
    },
    resetPanelsInLeftSection() {
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.RESET);
    },
    saveProduct() {
      EventBus.$emit('showHideLoader', true);
      setTimeout(() => {
        this.isGeneratePDFWithOutProof = true;
        this.generatePDF();
      }, 100);
    },

    openDropDown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    onSaveProduct() {
      this.$store.commit('setSaveApiMethod', 'NewEditorSave');
      this.saveProduct();
    },
    createNewOrder() {
      this.$store.commit('setSaveApiMethod', 'NewEditorSave');
      this.openDropDown();
      //  this.$store.commit('updateOrderItemId', ''); // TODO:when we empty orderItemId the saveProduct process saved as new product and
      this.saveProduct();
    },
    saveAsOrder() {
      this.$store.commit('setSaveApiMethod', 'NewEditorSaveAs');
      this.openDropDown();
      // this.$store.commit('updateOrderItemId', ''); // TODO:when we empty orderItemId the saveProduct process saved as new product and
      this.saveProduct();
    },
    saveAsTemplate() {
      this.$store.commit('setSaveApiMethod', 'NewEditorSaveAsTemplate');
      this.openDropDown();
      EventBus.$emit('showHideLoader', true);
      setTimeout(() => {
        this.isGeneratePDFWithOutProof = true;
        this.generatePDF(true);
      }, 100);
    },
    updateOrder() {
      this.openDropDown();

      this.$store.commit('setIsSavedAndClosed', true);
      try {
        this.$store.commit('setSaveApiMethod', 'NewEditorSave');
        this.saveProduct();
      } catch (e) {
        this.$store.commit('setIsSavedAndClosed', false);
      }
    },
    onSubmitProductWithVideo() {
      if (this.isPreviewVideo && this.undoRedoArrayLength === this.$store.getters.getUndoRedoArrayListLength) {
        this.$store.commit('setDisplayPreviewModal', true);
        this.$store.commit('setIsLoaderVisible', true);
        this.$store.commit('setSubmittedAs', 'video');
        EventBus.$emit('showHideLoader', true);
        // this.$store.commit('setSaveApiMethod', 'NewEditorSubmit');
      } else {
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'SaveReq', message: 'Please preview the Video before ordering.' });
      }
    },
    onSubmitProduct() {
      console.log(this.isPreviewPdf, 'isPreviewPdf');
      console.log(this.undoRedoArrayLength, 'this.undoRedoArrayLength');
      console.log(this.$store.getters.getUndoRedoArrayListLength, 'getUndoRedoArrayListLength');
      if ((this.isPreviewPdf && this.undoRedoArrayLength === this.$store.getters.getUndoRedoArrayListLength)) {
        this.$store.commit('setSaveApiMethod', 'NewEditorSubmit');
        this.$store.commit('setSubmittedAs', 'image');
        try {
          this.saveProduct();
        } catch (e) {
          this.$store.commit('setSaveApiMethod', '');
        }
      } else {
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'SaveReq', message: 'Please preview the PDF before ordering.' });
      }
    },
    onReturnBack() {
      window.history.back();
    },
    async getNewProductByOrder(orderItemId) {
      const domainUrl          = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url                = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=NewEditorGetV2&domainURL=https://${domainUrl}.com/&orderItemId=${orderItemId}`;
      const res                = await axios.get(url);
      const parser             = new DOMParser();
      const xmlParsed          = parser.parseFromString(res.data, 'text/xml');
      let newEditorGetResponse = xmlParsed.getElementsByTagName('NewEditorGetV2Result');
      if (newEditorGetResponse) { newEditorGetResponse = newEditorGetResponse[0]; }

      if (!newEditorGetResponse || (newEditorGetResponse.getElementsByTagName('OrderName').length == 0 || newEditorGetResponse.getElementsByTagName('Json').length == 0)) {
        return '';
      }

      const orderName = newEditorGetResponse.getElementsByTagName('OrderName');
      const orderJson = newEditorGetResponse.getElementsByTagName('Json');
      return { orderJson: orderJson[0].innerHTML, orderName: decodeURI(encodeURI(orderName[0].innerHTML)) };
    },
    handlePreviewClick() {
      if (this.isVideoMoodOn) {
        this.showPreviewDD = !this.showPreviewDD;
        return;
      }
      this.generatePDF();
    },
    handleSubmitClick() {
      if (this.isVideoMoodOn) {
        this.showSubmitDD = !this.showPreviewDD;
        return;
      }
      this.onSubmitProduct();
    },
  },
};

</script>
<style lang="scss" scoped>
@import url('//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
  .main-header {
    z-index: 1;

    .left-nav-content {
      flex: 0 0 360px;

      @include custom(1100px) {
        flex: auto;
      }
      @include custom(991px) {
        padding-right: 0px;
      }
    }

    .right-nav-content {
      flex: 0 0 360px;
      @include custom(991px) {
        display: none !important;
      }
    }

    .breadcrumb-wrapper {
      flex: 1 1 auto;
      @include custom(991px) {
      }
    }

    .avatar-section {
      flex: 0 0 500px;
    }

    .return-btn {

      .return-text {
        @include FontVariation(1.4rem, 600,'Open Sans',$white);
        line-height: 20px;
      }
    }

    .breadcrumb {
      @include FontVariation(1.4rem, normal,'Open Sans',$grey50);
      line-height: 24px;

      .breadcrumb-item {
        a {
          &:hover {
            color: $white !important;
          }
        }

        + {
          .breadcrumb-item {
            padding-left: 2.9px;

            &:before {
              padding-right: 2.9px;
            }

          }
        }
      }
    }
    .avatar-image-wrapper {
      height: 40px;
      width: 40px;
      cursor: pointer;
      border-radius: 50%;
    }

    .custom-select{
      width: 120px;
      height: 30px;
      font-size: 12px;
      appearance: revert;
    }
    .disable-button{
      background-color: #c2d0d9 !important;
      cursor:auto !important
    }
  }

.show-dropdown {
  .drop-down-list{
    display:block !important;
  }

  .right-icon{
    transform: rotate(-180deg);
  }
}


.right-icon{
  cursor:pointer;
}

.drop-down-list{
  display: none;
  top:36px;
  background-color:#FFFFFF;
  border-radius:0px 0px 4px 4px;
  text-align:left;
  cursor:pointer;
  border: 1px solid $grey40;

  li{
    color: $grey80;
    &:first-child{
      border-bottom: 1px solid $grey40;
    }
  }
}
ul.save-menu{
  top:37px;
  filter:drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.04)) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
  border:solid thin #ededed;
  width: 130px;
  border-radius: 8px;
  li{
    border: none !important;
    color:#3f3f3f;
    text-align: center;
    margin:12px 0px;
    padding: 0px;
    font-size: 14px;
    font-family: 'open sans';
  }
  &:before{
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    top: -10px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0px auto;

  }
  &.save-dd{
    top: 37px;
  }
}

.closer{
  position: absolute;
  height: 200vh;
  width: 200vw;
  left: -100vw;
  top: -100vh;
  z-index: 9999;
}


</style>
